var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAllEraser = function SvgAllEraser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "all_eraser_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".all_eraser_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "all_eraser_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "all_eraser_svg__st1",
    d: "M23 23.91H1c-.55 0-1-.45-1-1s.45-1 1-1h22c.55 0 1 .45 1 1s-.45 1-1 1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "all_eraser_svg__st0",
    d: "m16.1 20.81-6.4-6.38-3.19 3.19 5.52 5.51h1.74z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "all_eraser_svg__st0",
    d: "M13.77 23.13h-1.74l.87.87z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "all_eraser_svg__st1",
    d: "M23.56 15.49c.59-.59.59-1.54 0-2.13l-6.39-6.38c-.59-.59-1.54-.59-2.13 0L9.71 12.3l-4.26 4.25c-.59.59-.59 1.54 0 2.13l4.46 4.45h2.13l-5.53-5.52 3.2-3.19 6.39 6.38-2.33 2.33h2.13l2.33-2.33 5.33-5.31zM9.5 1.5H7v-1c0-.28-.22-.5-.5-.5h-3c-.28 0-.5.22-.5.5v1H.5c-.28 0-.5.22-.5.5s.22.5.5.5h9c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zM4 1h2v.5H4V1zM1 3v7.99c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V3H1zm2.5 6.98c0 .28-.22.5-.5.5s-.5-.22-.5-.5V4.99c0-.28.22-.5.5-.5s.5.22.5.5v4.99zm2 0c0 .28-.22.5-.5.5s-.5-.22-.5-.5V4.99c0-.28.22-.5.5-.5s.5.22.5.5v4.99zm2 0c0 .28-.22.5-.5.5s-.5-.22-.5-.5V4.99c0-.28.22-.5.5-.5s.5.22.5.5v4.99z"
  })));
};
export default SvgAllEraser;